import { 
    SET_ERRORS,
    GET_ALL_POSTS,
    POST_ONE_POST,
    LOADING_UI,
    STOP_LOADING_UI,
    LOADING_POST,
    SET_POST,
    UPDATE_POST,
    FILTER_POST,
    SET_NOTY,
    CLEAR_ERRORS,
 } from '../types';
import axios from 'axios';

export const postOnePost = (dataPost, history) => (dispatch) => {
    dispatch({type: LOADING_POST});
    axios.post('/post', dataPost)
        .then(res => {
            dispatch({
                type: POST_ONE_POST,
                payload: res.data
            });
            history.push('/bai-viet');
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        })
}
export const getAllPosts = () => dispatch => {
    dispatch({type: LOADING_UI});
    axios.get(`/posts/`)
        .then(res => {
            dispatch({
                type: GET_ALL_POSTS,
                payload: res.data
            })
            dispatch({ type: STOP_LOADING_UI })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_POSTS,
                payload: []
            })
        })
}

export const getPost = (postId) => (dispatch) => {
    dispatch({type: LOADING_POST});
    axios
    .get(`/post/${postId}`)
    .then(res => {
        dispatch({
            type: SET_POST,
            payload: res.data
        })
    })
    .catch(err => {
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
        })
    })
}

export const updatePost = (postId, dataPost) => dispatch => {
    dispatch({type: LOADING_UI});
    axios.post(`/post/${postId}`, dataPost)
        .then(res => {
            dispatch({
                type: SET_NOTY,
                payload: res.data.message
            })
        })
        .then(() => {
          dispatch({
              type: UPDATE_POST,
              payload: dataPost,
              postId,
          })
        })
        .catch(err => console.log(err));
  }

export const filterPost = (filter) => dispatch => {
    dispatch({
        type: FILTER_POST,
        filter
    })
}

export const clearErrors = () => dispatch => {
    dispatch({ type: CLEAR_ERRORS });
}